var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hcp-tag-cell" },
    [
      _vm.tags.length
        ? [
            _vm.tags.length > 1
              ? _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "bottom-start",
                      trigger: "hover",
                      "popper-class": "hcp-tag-popover",
                      "open-delay": 100,
                    },
                  },
                  [
                    _c("div", { staticClass: "all-tags" }, [
                      _c("div", { staticClass: "pop-title" }, [
                        _vm._v("All Tags "),
                        _c("span", [_vm._v(_vm._s(_vm.tags.length))]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "pop-grid" },
                        _vm._l(_vm.groupedTags, function (group) {
                          return _c(
                            "div",
                            { key: group.id, staticClass: "pop-row" },
                            [
                              _c("span", { staticClass: "pop-label" }, [
                                _vm._v(_vm._s(group.name)),
                              ]),
                              _c(
                                "div",
                                { staticClass: "pop-chips" },
                                _vm._l(group.values, function (tag) {
                                  return _c(
                                    "span",
                                    {
                                      key: tag.id,
                                      staticClass: "hcp-tag-chip",
                                      class: tag.color,
                                    },
                                    [_vm._v(" " + _vm._s(tag.name) + " ")]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "tag-trigger",
                        attrs: { slot: "reference" },
                        slot: "reference",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "hcp-tag-chip name",
                            class: _vm.visibleTag.color,
                          },
                          [_vm._v(_vm._s(_vm.visibleTag.name))]
                        ),
                        _c("span", { staticClass: "hcp-tag-chip more" }, [
                          _vm._v("+" + _vm._s(_vm.restCount)),
                        ]),
                      ]
                    ),
                  ]
                )
              : _c(
                  "span",
                  { staticClass: "hcp-tag-chip", class: _vm.visibleTag.color },
                  [_vm._v(_vm._s(_vm.visibleTag.name))]
                ),
          ]
        : _c("span", [_vm._v("-")]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }